export const bannerList = [
  {
    id: "b1",
    mediaId: "m4",
    title: "星海征途",
    tagline: "年度科幻巨制 · 跨越虫洞的星际远征",
    summary: "人类首次穿越虫洞寻找第二家园，一支精英舰队在星际航行中遭遇未知文明的考验。宇宙的尽头，等待他们的是希望还是毁灭。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20space%20sci-fi%20scene%20of%20a%20lone%20spaceship%20flying%20toward%20a%20glowing%20wormhole%20among%20stars%20and%20nebula%2C%20deep%20dark%20blue%20and%20orange%20toned%20cinematic%20atmosphere%2C%20wide%20composition%2C%20high%20detail&width=1920&height=1080&seq=herobanner-01&orientation=landscape",
  },
  {
    id: "b2",
    mediaId: "m1",
    title: "长夜将尽",
    tagline: "年度口碑悬疑 · 一桩尘封十五年的旧案",
    summary: "退休刑警在追查真相的过程中，逐渐发现自己也深陷其中。城市的霓虹之下，每个人都藏着不愿示人的秘密。",
    image:
      "https://readdy.ai/api/search-image?query=Noir%20rainy%20city%20street%20at%20night%20with%20neon%20signs%20reflecting%20on%20wet%20ground%2C%20lone%20figure%20silhouette%2C%20moody%20dark%20blue%20and%20amber%20cinematic%20atmosphere%2C%20wide%20composition%2C%20high%20detail&width=1920&height=1080&seq=herobanner-02&orientation=landscape",
  },
  {
    id: "b3",
    mediaId: "t1",
    title: "长安十二时辰录",
    tagline: "古装悬疑大剧 · 十二个时辰救一座城",
    summary: "上元佳节前夕，长安城暗流涌动。一名死囚与一位少年联手，在十二个时辰内阻止一场足以颠覆王朝的阴谋。",
    image:
      "https://readdy.ai/api/search-image?query=Ancient%20chinese%20tang%20dynasty%20city%20at%20dusk%20with%20thousands%20of%20lanterns%2C%20palace%20roofs%20and%20golden%20glow%2C%20rich%20red%20and%20gold%20epic%20cinematic%20atmosphere%2C%20wide%20composition%2C%20high%20detail&width=1920&height=1080&seq=herobanner-03&orientation=landscape",
  },
  {
    id: "b4",
    mediaId: "m8",
    title: "冰封之城",
    tagline: "灾难巨制 · 零下五十度的绝境求生",
    summary: "突如其来的极寒气候将整座城市冰封，一群素不相识的幸存者被困在地铁站内。人类的信念才是最后的火种。",
    image:
      "https://readdy.ai/api/search-image?query=Frozen%20apocalyptic%20city%20skyline%20covered%20in%20snow%20and%20ice%20under%20dark%20stormy%20sky%2C%20cold%20blue%20and%20white%20chilling%20cinematic%20atmosphere%2C%20wide%20composition%2C%20high%20detail&width=1920&height=1080&seq=herobanner-04&orientation=landscape",
  },
  {
    id: "b5",
    mediaId: "t2",
    title: "都市夜归人",
    tagline: "都市情感剧 · 深夜便利店里的相遇",
    summary: "三个在大城市打拼的年轻人，各自背负着生活的重量，却在彼此身上找到了继续前行的勇气。",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20city%20street%20at%20night%20with%20warm%20streetlights%20and%20glowing%20office%20towers%2C%20soft%20blue%20and%20amber%20urban%20cinematic%20atmosphere%2C%20wide%20composition%2C%20high%20detail&width=1920&height=1080&seq=herobanner-05&orientation=landscape",
  },
];